import { Button } from "@blueskydataplatform/shared-ui/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@blueskydataplatform/shared-ui/components/ui/card";

import Logo from "@/components/logo";
import { GENERIC_CLIENT } from "@/features/login/mcp-client-name";

/**
 * Shown when the handshake fails on the already-signed-in path, which renders nothing but
 * a hidden form — a failure there left a blank page with a toast fading out over it, and
 * no way to try again short of starting over in the LLM client.
 */
const McpConnectionFailed = ({
  message,
  clientName,
  onRetry,
  isRetrying,
  cancelled = false,
}: {
  message: string;
  clientName: string | null;
  onRetry?: () => void;
  isRetrying: boolean;
  /** The visitor said no on the consent dialog: nothing failed, and nothing to troubleshoot. */
  cancelled?: boolean;
}) => (
  <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <Card className="w-full max-w-2xl shadow-sm">
      <CardHeader className="space-y-3">
        <div className="flex justify-center">
          <Logo className="mb-4" />
        </div>
        <CardTitle className="text-2xl font-bold text-center">
          {cancelled ? "Connection cancelled" : `We couldn’t finish connecting ${clientName ?? GENERIC_CLIENT}`}
        </CardTitle>
        <CardDescription className="text-center max-w-md mx-auto">{message}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {onRetry && (
          <div className="flex items-center justify-center">
            <Button onClick={onRetry} disabled={isRetrying}>
              {isRetrying ? "Trying again…" : "Try again"}
            </Button>
          </div>
        )}
        {!cancelled && (
          <p className="text-sm text-muted-foreground text-center max-w-md mx-auto">
            {`If this keeps happening, start the connection again from ${clientName ?? GENERIC_CLIENT}.`}
          </p>
        )}
      </CardContent>
    </Card>
  </div>
);

export default McpConnectionFailed;
